import React from 'react';
import { ChevronRight } from 'lucide-react';

interface AccordionProps {
  title: string;
  titleClassName?: string;
  icon?: React.ReactNode;
  onClick: () => void;
}

const Accordion: React.FC<AccordionProps> = ({
  title,
  titleClassName,
  icon,
  onClick,
}) => {
  return (
    <div className="group mb-4 rounded-lg border border-border shadow-accordion transition-colors duration-200 hover:border-primary hover:bg-surface-alt">
      <button
        onClick={onClick}
        className="flex w-full items-center justify-between p-4 text-left"
      >
        <div className="flex items-center">
          {icon && (
            <div className="mr-2 transition-transform duration-200 group-hover:scale-110">
              {icon}
            </div>
          )}
          <span className={titleClassName}>{title}</span>
        </div>
        <ChevronRight className="text-text-muted transition-transform duration-200 group-hover:translate-x-1" />
      </button>
    </div>
  );
};

export default Accordion;